import store from '../stores/configureStore'

function getReferrerUrl() {
  // get the previous browing history url
  const previousUrlState = (document && document.referrer) || ''

  // convert the url string into an array
  const urlSplit = previousUrlState.split('/')

  // extract the last two elements from the array and construct the url
  return urlSplit.slice(-2).join('/')
}

export function getGoToLink() {
  const { server: { env } = {} } = store.getState()
  // if user comes from summary page, return them to summary
  if (env === 'summary') {
    return '/myaccount/summary?lastAction=sendMoney'
  }
  const referrerUrl = getReferrerUrl()
  const shouldLinkToActivity = referrerUrl === 'myaccount/activity'
  return shouldLinkToActivity
    ? '/myaccount/activity'
    : '/myaccount/home?lastAction=sendMoney'
}

export function getGoToLinkContentKey() {
  const referrerUrl = getReferrerUrl()
  const shouldLinkToActivity = referrerUrl === 'myaccount/activity'
  return shouldLinkToActivity ? 'success.goToActivity' : 'success.goToSummary'
}
